import React from "react";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";
import { Image } from "../Image";
import { isEmpty, maxFrequent } from "oc-commons/Commons";
import Select from "react-select";
import classnames from "classnames";
import { filterPathIntersectionCached } from "oc-app/metadata/GraphMetadata";
import { MAuswahlwert, MObjekt } from "../../../metamodell";
import { PPfosten } from "../../../metamodell_paths";

export function ZaunCircleMenuItemAnker() {
  const agt = APP.arrangement;
  const pfosten = agt.selectedObjects.filter(
    (p) => p.isPfosten && isEmpty(p.meta?.Torpfostenseite)
  );
  const ankerAuswahlwert = maxFrequent(pfosten.map((p) => p.ankerAuswahlwert));

  const contract = () => {
    return pfosten.length > 0;
  };
  if (!contract()) {
    return null;
  }

  const optionen = [
    ...filterPathIntersectionCached("ZaunCircleMenuItemAnker.jsx:24")(
      _.first(pfosten).meta,
      (p: PPfosten) => p.Sturmanker
    ),
    ...filterPathIntersectionCached("ZaunCircleMenuItemAnker.jsx:25")(
      _.first(pfosten).meta,
      (p: PPfosten) => p.Windanker
    ),
  ] as MObjekt[];
  const options: { value: string | null; wert?: MAuswahlwert; label: React.ReactNode }[] =
    optionen.map(({ Auswahlwert }) => ({
      value: Auswahlwert.Key,
      wert: Auswahlwert,
      label: (
        <div className="dropdown-entry" aria-label={Auswahlwert.AriaText || Auswahlwert.Name}>
          {!isEmpty(Auswahlwert.Auswahlbild) && (
            <Image url={Auswahlwert.Auswahlbild} width="6em" height="6em" />
          )}
          <div className={classnames("text", !isEmpty(Auswahlwert.Auswahlbild) && "with-image")}>
            {isEmpty(Auswahlwert.Bezeichnung) ? Auswahlwert.Name : Auswahlwert.Bezeichnung}
          </div>
        </div>
      ),
    }));
  options.unshift({ value: null, label: "-" });

  if (options.length < 2) {
    return null;
  }

  const changeAnker = (v) => {
    pfosten.forEach((p) => {
      p.ankerAuswahlwert = v.wert;
      v.value && agt.ankerAußen.add(p);
    });
    APP.logUserAction({ action: "setAnker", value: v.wert });
    APP.dirty();
  };

  return (
    <ZaunCircleMenuItem
      className={"onTop"}
      dataButtonKey={I18N("aria::Anker auswählen")}
      onClick={(event) => {
        event.stopPropagation();
        const input = (event.target as HTMLElement).querySelector("input");
        input && input.focus();
      }}
    >
      <div className="flex-column align-items-start" data-input-key={I18N("Anker")}>
        <label htmlFor="anker-select">{I18N("Anker")}</label>
        <Select
          id="anker-select"
          aria-label={I18N("aria::Ankertyp auswählen")}
          classNamePrefix="my-select"
          className="select"
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          value={options.find((o) => o.value == ankerAuswahlwert?.Key)}
          options={options}
          onChange={changeAnker}
        />
      </div>
    </ZaunCircleMenuItem>
  );
}
